<template>
	<div  class="pageArea">
		<Head2></Head2>
		<div class="mainAea">
			<div class="sortTitle">{{$t('pages.comment.breadcrumb')}}</div>
			<div class="title">{{$t('pages.comment.title')}}</div>
			<div class="orerNum">{{$t('pages.comment.platform_order_no')}}{{orderInfo.order_no}}<span>|</span>{{$t('pages.comment.order_time')}}{{orderInfo.gmt_order}}</div>
			<div class="card" v-for="(item, index) in orderInfo.detail_list" :key="index">
				<div class="cardLeft">
					<img src="../assets/images/peoImg2.png"/>
					<div class="proTitle">{{item.product_name}}</div>
					<div class="proType">{{item.cate_name}}</div>
					<div class="proNum">
						{{item.sku_text}}
					</div>
				</div>
				<div class="cardRight">
					<div class="cardli">
						<div class="cardLiText">{{$t('pages.comment.product_score')}}</div>
						<div  class="cardRi">
							<Rate :max='5' :selected="formInfo[index].score" :formIndex="index" @rating-changed="updateRating"></Rate>
							<span>{{$t('pages.appraisal.score_format',{score: formInfo[index].score})}}</span>
						</div>
					</div>
					<div class="cardli">
						<div class="cardLiText">{{$t('pages.comment.evaluation_content')}}</div>
						<div  class="cardRi">
							<textarea :placeholder="$t('pages.comment.textarea_placeholder')" v-model="formInfo[index].content"></textarea>
						</div>
					</div>
					<div class="cardli">
						<div class="cardLiText">{{$t('pages.comment.share_images')}}</div>
						<div class="cardRi"> 
							<div  class="uploadImgs">
								<div v-for="(image,imageIndex) in formInfo[index].images" :key="imageIndex">
									<img :src="image"/>
									<button @click="removeImage(imageIndex,index)">{{$t('pages.comment.delete')}}</button>
								</div>
								<div class="updateArea">
									<input type="file" :ref="setItemRef(index)"  @change="handleUpdate(`fileInput${index}`,index)"/>
									<img src="../assets/images/update.png"  @click="uploadImage(`fileInput${index}`,index)"/>
								</div>
							</div>
							<div class="tipText" v-html="$t('pages.comment.tip_text',{count: formInfo[index].images.length, max:6})"></div>
						</div>
					</div>
				</div>
			</div>			
			<div class="card columnFlex">
				<div class="btn" @click="submit">{{$t('pages.comment.submit_btn')}}</div>
				<div class="checkBoxArea">
					<input type="checkbox"  v-model="isAnony" />
					<div>{{$t('pages.comment.anonymous_label')}}</div>
				</div>
			</div>
		</div>
		<Foot2></Foot2>
	</div>
</template>

<script>
	import Head2 from '../components/head2.vue';
	import Foot2 from '../components/foot2.vue';
	import Rate from '../components/rate.vue';
	export default{
		components:{
			Head2,
			Foot2,
			Rate
		},
		data(){
			return{
				rating: 0,
				editableRating: 0,
				orderId:0,
				orderInfo:{},
				formInfo:[],
				isAnony:0,
				
			}
		},
		created(){
			this.orderId=this.$route.query.id;
			this.getOrderInfo();
		},
		methods:{
		   setItemRef(index) {
			  return `fileInput${index}`;
			},
			updateRating(newRating,formIndex){
				
				this.formInfo[formIndex].score=newRating
			},
			getOrderInfo()
			{
				this.$scUtil.axiosPost(this, 'OrderApi/GetOrderInfo', {
					orderId: this.orderId,
					userName: localStorage.getItem('username'),
				}, res => {
					if (res.code == 100) {
						this.orderInfo = res.data[0];
						//console.log(JSON.stringify(this.orderInfo));
						let count=Number(this.orderInfo.detailcount);
						for(let i =0; i<count; i++)
						{
								let sku_id=this.orderInfo.detail_list[i].sku_id;
								let product_id=this.orderInfo.detail_list[i].product_id;
								this.formInfo.push({index:i,productId:product_id,sku_id:sku_id,score:0,content:"",images:[],imagesstr:""})
						}
						console.log(JSON.stringify(this.formInfo));
					}
					else
					{
						 this.$message(res.message);
						 this.$router.push({ name: "myVue" });
					}
				
				});
			},
			uploadImage(refName,index){
				this.$refs[refName][0].click();
			},
			handleUpdate(refName,index){
				 const file = this.$refs[refName][0].files[0];
				 
				 const validTypes = ['image/jpeg', 'image/png', 'image/gif','image/jpg'];
			 	
				const maxSize = 6 * 1024 * 1024; // 6 MB
				// 检查文件类型			
				if (!validTypes.includes(file.type)) { 		
				  this.$message({message: this.$t('pages.comment.image_type_error'),type: "warning"});			
				  return;	
				}
				// 检查文件大小		
				if (file.size > maxSize) { 			
				  this.$message({message: this.$t('pages.comment.image_size_error'),type: "warning"});
				  return;
				}
				if(this.formInfo[index].images.length==6)
				{
					this.$message({message: this.$t('pages.comment.image_max_error',{max:6}),type: "warning"});
					return;
				}
				 //console.log(file);
				 const formData = new FormData();	 
				 formData.append('fileList', file);		 
				this.$scUtil.axiosUpload(this, 'UploadApi/UploadFile?fileModule=6', formData, res => {				
					if (res.code == 100) {
						this.formInfo[index].images.push(this.$scUtil.globalData.apiServer+res.data.filename)
					}
			 
				});
			},
			removeImage(i,index)
			{
				this.formInfo[index].images.splice(i, 1);
			},
			submit()
			{
				this.formInfo.forEach(p=>{
					p.imagesstr=JSON.stringify(p.images);
				})
				let isAnonyFlag=0;
				if(this.isAnony){
					isAnonyFlag=1;
				}
				this.$scUtil.axiosPut(this, 'EvaluateApi/AddEvaluate', {
					userName:localStorage.getItem('username'),
					orderId:this.orderId,
					formInfo:JSON.stringify(this.formInfo),
					isAnonyFlag:isAnonyFlag
				}, res => {
					//console.log(res.code);
					if (res.code == 100) {
						this.$message({
							message: res.message,
							type: "success"
						});
						this.$router.push({name:'MyVue'})
						return;
						
					}else
					{
						this.$message({
							message: res.message,
							type: "warning"
						});
					}
										
				});
			}
		},		
		watch: {
			isAnony() { // 监听select
				
			}
		}
	}
</script>

<style scoped>
	.pageArea{
		background-color: #ebecee;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.mainAea{
		width: 1200px;
	}
	
	.sortTitle{
		font-size: 13px;
		color: #333333;
		height: 44px;
		line-height: 44px;
	}
	
	.title{
		font-size: 18px;
		color: #000000;
		margin-top: 20px;
		width: 100%;
		text-align: center;
	}
	
	.orerNum{
		font-size: 13px;
		color: #000000;
		margin-top: 20px;
		width: 100%;
		text-align: center;
		margin-bottom: 30px;
	}
	.orderNum span{
		color: #666;
		margin: 0 30px;
	}
	
	.card{
		width: 1200px;
		background-color: #fff;
		display:flex;
		margin-bottom: 20px;
	}
	
	.cardLeft{
		width: 324px;
		border-right: 1px solid #e2e2e2;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 80px 30px 80px;
		box-sizing: border-box;
	}
	
	.cardLeft img{
		width: 105px;
		height: 105px;
		border: 1px solid #e6e6e6;
		margin-top: 58px;
	}
	
	.proTitle{
		font-size: 13px;
		color: #000000;
		text-align: center;
		margin-top: 24px;
		line-height: 25px;
	}
	
	.proType{
		font-size: 12px;
		color: #000000;
		text-align: center;
		margin-top: 15px;
	}
	
	.proNum{
		font-size: 12px;
		color: #888888;
		text-align: center;
		margin-top: 20px;
	}
	
	
	.cardRight{
		padding:40px 40px 0 40px;
		box-sizing: border-box;
		flex: 1;
	}
	
	.cardli{
		display: flex;
		align-items: flex-start;
		margin-bottom: 20px;
	}
	
	.cardLiText{
		width: 115px;
		min-width: 115px;
		text-align: left;
		font-size: 13px;
		color: #000000;
	}
	
	.cardRi{
		color: #000000;
		font-size: 13px;
		display: flex;
		line-height: 30px;
		flex-wrap: wrap;
		align-items: center;
	}
	
	.cardRi span{
		padding-bottom: 10px;
		margin-left: 10px;
	}
	
	.cardRi img{
		width: 50px;
		height: 50px;
		border: 1px solid #e2e2e2;
		margin:0 11px 11px 0;
	}
	
	
	.cardRi textArea{
		width: 635px;
		height: 163px;
		border: 1px solid #e2e2e2;
		padding: 20px;
		box-sizing: border-box;
		font-size: 13px;
		color: #000;
	}
	
	.cardRi textArea::placeholder{
		color:#666666;
	}
	
	.cardRi textArea:focus{
		outline: none;
	}
	
	.updateArea{
		position: relative;
		width: 88px;
		height: 88px;
	}
	
	.updateArea img{
		position: absolute;
		top: 0;
		left: 0;
	}
	
	.updateArea input{
		display: none;
	}
	
	.uploadImgs{
		display: flex;
		flex-wrap: wrap;
	}
	
	.uploadImgs img{
		min-width: 88px;
		width: 88px;
		height: 88px;
		margin-right: 15px;
	}
	
	.tipText{
		font-size: 13px;
		color: #888888;
		margin-left: 10px;
	}
	
	.tipText span{
		color: #0380fe;
		margin: 0 10px;
	}
	
	.columnFlex{
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 30px 0 ;
	}
	
	.btn{
		width: 288px;
		height: 50px;
		background-color: #0380fe;
		color: #fff;
		font-size: 18px;
		color: #fff;
		text-align: center;
		line-height: 50px;
		cursor: pointer;
	}
	
	.checkBoxArea{
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #333333;
		margin-top: 18px;
	}
	
	.checkBoxArea input{
		border: 1px solid #dad9d9;
		margin-right: 11px;
		cursor: pointer;
	}
</style>